<template>
  <div
    role="radio"
    tabindex="0"
    :aria-checked="isChecked"
    :class="[ { 'border-neutral-200 bg-transparent' : !isChecked }, { 'border-petrol-500 bg-petrol-50' : isChecked }, 'rounded-md border-2 inline-block font-semibold cursor-pointer']"
    @click="toggle"
    @keydown.enter.prevent="toggle"
    @keydown.space.prevent="toggle"
  >
    <div class="flex items-center cursor-pointer">
      <div class="py-2 px-2">
        <div v-if="$slots.icon">
          <slot name="icon" />
        </div>
        <slot />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from 'vue'

const props = defineProps({
  value: {
    type: [String, Number, Array, Boolean],
    default: null
  },
  checkedValue: {
    type: [String, Number, Array, Boolean],
    required: true
  },
  uncheckedValue: {
    type: [String, Number, Array, Boolean],
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])

const isChecked = ref(props.value === props.checkedValue)

watch(() => props.value, (newValue) => {
  isChecked.value = newValue === props.checkedValue
})

const toggle = () => {
  emit('update:modelValue', isChecked.value ? props.uncheckedValue : props.checkedValue)
}
</script>
